import gql from "graphql-tag";

export const UpdateAccountInfo = gql`
  mutation updateAccountInfo($account: UpdateAccountInput) {
    updateAccountInfo(account: $account)
  }
`;
export const UpdateAccountEmail = gql`
  mutation UpdateAccountEmail($email: String!) {
    updateAccountEmail(email: $email)
  }
`;

export const UpdateAccountPassword = gql`
  mutation UpdateAccountPassword(
    $password: String!
    $confirmPassword: String!
  ) {
    updateAccountPassword(
      password: $password
      confirmPassword: $confirmPassword
    )
  }
`;
